import { render, staticRenderFns } from "./ZdmRelationWidget.vue?vue&type=template&id=41f2d9da&scoped=true&"
import script from "./ZdmRelationWidget.vue?vue&type=script&lang=js&"
export * from "./ZdmRelationWidget.vue?vue&type=script&lang=js&"
import style0 from "./ZdmRelationWidget.vue?vue&type=style&index=0&id=41f2d9da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2d9da",
  null
  
)

export default component.exports